export default {
  methods: {
    formatName (value) {
      const formattedName = {}
      let firstName = ''
      let lastName = ''
      if (value.includes(',')) {
        firstName = value
          .split(', ')[1]
          .split(' ')[0]
          .toLowerCase()
        lastName = value.split(', ')[0].toLowerCase()
      } else {
        firstName = value.split(' ')[0].toLowerCase()
        lastName = value.split(' ')[1].toLowerCase()
      }
      const fullName = `${firstName} ${lastName}`
      formattedName.initials = `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`
      formattedName.firstName = this.capitalize(firstName)
      formattedName.lastName = this.capitalize(lastName)
      formattedName.fullName = this.capitalize(fullName)
      return formattedName
    },
    capitalize (name) {
      return name
        .split(' ')
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
    },
  },
}
